import { getWidthBlock } from '../getWidthBlock'

export const styles = () => ({
  attachment: {
    textDecoration: 'none',
    color: '#1658F3',
    marginLeft: '15px',
    alignItems: 'center',
  },
  attachmentSpan: {
    marginRight: '8px',
  },
})

export const templateAttachmentStyle = (device, url, received) => ({
  width: getWidthBlock(device),
  backgroundImage: `url('${url}')`,
  backgroundSize: 'auto 140px',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  marginRight: received ? '' : '10px',
})
